import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Typography,
  Paper,
  Divider,
  Select,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import "../../styles/partCreation.css";
import { automationHttpRequest } from "../../api/httpRequests";
import FormControl from "@mui/material/FormControl";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import TextField from "@mui/material/TextField";
import JustificationDialog from "./JustificationDialog";

const PirData = ({
  setShowPirData,
  setPirValue,
  handleContinue,
  checkPartData,
}) => {
  const [currency, setCurrency] = useState("USD");
  const [leadTime, setLeadTime] = useState("Days");
  const [predictedUsage, setPredictedUsage] = useState("Days");
  const [disablePir, setDisablePir] = useState(true);
  const [justificationOpen, setJustificationOpen] = useState(false);
  const [pirDataValue, setPirDataValue] = useState({
    vendor_account: "",
    supplier_part_number: "",
    lead_time_from_pir: "",
    base_uom: "EA",
    standard_price: "",
    order_uom: "EA",
    predticed_usage: "",
    justification_for_net_price_change: "",
    base_unit: 1,
    order_unit_from_pir: 1,
  });

  const [conversionValue, setConversionValue] = useState({
    order_unit: 1,
    base_unit: 1,
  });

  const options = ["USD", "CAD", "EUR", "GBP", "JPY"];
  const leadTimeOptions = ["Days", "Months", "Years"];
  const uomOptions = [
    "DZ",
    "FT",
    "RL",
    "MIL",
    "M",
    "TH",
    "BOX",
    "DR",
    "BTE",
    "KG",
    "BAG",
    "L",
    "EA",
    "PAK",
    "PAC",
    "GLL",
    "PAA",
    "CS",
    "LB",
    "PAQ",
  ];
  const [vendorNames, setVendorNames] = useState([]);
  const [optionToShow, setOptionToShow] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    fetchVendorNames();
  }, []);

  const fetchVendorNames = async () => {
    setFetching(true);
    try {
      const response = await automationHttpRequest.post(
        "/get_vendor_details/",
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
        }
      );
      if (response?.data?.status) {
        setVendorNames(response?.data?.data);
        setOptionToShow(response?.data?.data.slice(0, 200));
        setFetching(false);
      }
    } catch (error) {
      console.error("Error fetching nouns:", error);
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 100,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };
  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    color: "#212F37",
    margin: "0px 10px",
  };
  const vendorInputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    color: "#212F37",
    margin: "0px 18px",
  };
  const inputStyleJustfication = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    color: "#212F37",
    margin: "6px 10px 0px 8px",
  };
  const handleSelectChange = (event) => {
    setCurrency(event?.target?.value);
    setPirValue((prevObject) => ({
      ...prevObject,
      currency: event?.target?.value,
    }));
  };
  const handlePredicatedValueChange = (event) => {
    setPredictedUsage(event?.target?.value);
  };

  const headingStyle = {
    fontWeight: "700",
  };

  const handleConversionChange = (event) => {
    if (event?.target?.name === "conversionOrder") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          order_unit: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          order_unit: "",
        }));
      }
    }
    if (event?.target?.name === "conversionBase") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          base_unit: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          base_unit: "",
        }));
      }
    }
  };

  useEffect(() => {
    handleDisable();
  });

  // useEffect(() => {
  //   if (typeof(pirDataValue?.standard_price)!== String && pirDataValue?.standard_price <= 15 && pirDataValue?.standard_price !== "") {
  //     setJustificationOpen(true)
  //   }
  // }, [pirDataValue?.standard_price]);

  useEffect(() => {
    if (checkPartData) {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        supplier_part_number: checkPartData?.supplier_part_number,
      }));
    }
  }, [checkPartData]);

  const handleChange = (event) => {
    if (event?.target?.name === "vendorNumber") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          vendor_account: numericValue,
        }));
        setPirValue((prevObject) => ({
          ...prevObject,
          vendor_account: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          vendor_account: "",
        }));
        setPirValue((prevObject) => ({
          ...prevObject,
          vendor_account: "",
        }));
      }
    }
    if (event?.target?.name === "supplierPartNumber") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        supplier_part_number: event?.target?.value,
      }));
      setPirValue((prevObject) => ({
        ...prevObject,
        supplier_part_number: event?.target?.value,
      }));
    }
    if (event?.target?.name === "leadTime") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          lead_time_from_pir: numericValue,
        }));
        setPirValue((prevObject) => ({
          ...prevObject,
          lead_time_from_pir: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          lead_time_from_pir: "",
        }));
        setPirValue((prevObject) => ({
          ...prevObject,
          lead_time_from_pir: "",
        }));
      }
    }
    if (event?.target?.name === "netPrice") {
      const isValid = /^[0-9,/.\\-\s]*$/.test(event?.target?.value);
      if (isValid) {
        const numericValue = parseInt(event?.target?.value, 10);
        if (!isNaN(numericValue) && numericValue != "") {
          setPirDataValue((prevObject) => ({
            ...prevObject,
            standard_price: event?.target?.value,
          }));
          let formattedValue = parseFloat(numericValue).toFixed(2);
          setPirValue((prevObject) => ({
            ...prevObject,
            standard_price: formattedValue,
          }));
        }
        if (event?.target?.value === "") {
          setPirDataValue((prevObject) => ({
            ...prevObject,
            standard_price: "",
          }));
          setPirValue((prevObject) => ({
            ...prevObject,
            standard_price: "",
          }));
        }
        if (parseInt(event?.target?.value) > 15) {
          setPirDataValue((prevObject) => ({
            ...prevObject,
            justification_for_net_price_change: "",
          }));
        }
      }
    }
    if (event?.target?.name === "orderUOM") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        order_uom: event?.target?.value,
      }));
      setPirValue((prevObject) => ({
        ...prevObject,
        order_uom: event?.target?.value,
      }));
    }
    if (event?.target?.name === "baseUOM") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        base_uom: event?.target?.value,
      }));
      setPirValue((prevObject) => ({
        ...prevObject,
        base_uom: event?.target?.value,
      }));
    }
    if (event?.target?.name === "predictedUsage") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          predticed_usage: numericValue,
        }));
        setPirValue((prevObject) => ({
          ...prevObject,
          predticed_usage: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          predticed_usage: "",
        }));
        setPirValue((prevObject) => ({
          ...prevObject,
          predticed_usage: "",
        }));
      }
    }
    if (event?.target?.name === "enterJustification") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        justification_for_net_price_change: event?.target?.value,
      }));
      setPirValue((prevObject) => ({
        ...prevObject,
        justification_for_net_price_change: event?.target?.value,
      }));
    }
    if (event?.target?.name === "baseUOM") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        base_uom: event?.target?.value,
      }));
      setPirValue((prevObject) => ({
        ...prevObject,
        base_uom: event?.target?.value,
      }));
    }
  };

  const handleSubmit = () => {
    let lead_time_from_pir = "";
    let predticed_usage = "";
    // Assuming pirDataValue is an object
    if (pirDataValue.standard_price) {
      let formattedValue = parseFloat(pirDataValue.standard_price);
      formattedValue = formattedValue.toFixed(2);
      pirDataValue.standard_price = +formattedValue;
    } else {
      pirDataValue.standard_price = "";
    }

    if (pirDataValue.lead_time_from_pir) {
      // Check if lead_time_from_pir is a valid number
      lead_time_from_pir = pirDataValue.lead_time_from_pir + " " + leadTime;
    }

    if (pirDataValue.predticed_usage) {
      // Check if lead_time_from_pir is a valid number
      predticed_usage = pirDataValue.predticed_usage;
    }

    // Update the standard_price property in pirDataValue with the formatted value
    const updatedDataValue = {
      ...pirDataValue,
      currency,
      uom_conversion:
        conversionValue?.base_unit + ":" + conversionValue?.order_unit,
      standard_price: +pirDataValue.standard_price, // convert to string for consistency
      lead_time_from_pir: lead_time_from_pir,
      base_unit: conversionValue?.base_unit,
      order_unit_from_pir: conversionValue?.order_unit,
      predticed_usage: predticed_usage.toString(),
    };
    setPirValue(updatedDataValue);
    if (
      pirDataValue?.standard_price <= 15 &&
      pirDataValue?.standard_price !== ""
    ) {
      setJustificationOpen(true);
    }
  };

  const handleReset = () => {
    setPirDataValue({
      vendor_account: "",
      supplier_part_number: "",
      lead_time_from_pir: "",
      base_uom: "EA",
      standard_price: "",
      order_uom: "EA",
      predticed_usage: "",
      justification_for_net_price_change: "",
      base_unit: 1,
      order_unit_from_pir: 1,
    });
  };

  const handleDisable = () => {
    const keysToExclude = [
      "base_uom",
      "order_uom",
      // "supplier_part_number",
      "justification_for_net_price_change",
    ];
    for (let key in pirDataValue) {
      if (keysToExclude.includes(key)) {
        continue;
      }
      if (!pirDataValue[key] && pirDataValue[key] !== 0) {
        return setDisablePir(false);
      }
    }
    setDisablePir(true);
  };

  const handleVendorNameChange = (val) => {
    setPirDataValue((prevObject) => ({
      ...prevObject,
      vendor_account: val,
    }));
  };

  const ButtonFamily = ({ btnText }) => {
    return (
      <>
        <button
          type="submit"
          className="submitButton"
          style={{
            fontSize: 16,
            cursor: !disablePir ? "default" : "pointer",
            position: "relative",
            fontFamily: "Verdana",
            background: !disablePir ? "#f5f5f5" : "#C6003D",
            color: !disablePir ? "#C6003D" : "#FFFFFF",
          }}
          disabled={!disablePir}
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
            if (
              !(
                pirDataValue?.standard_price <= 15 &&
                pirDataValue?.standard_price !== ""
              )
            ) {
              handleContinue();
            }
          }}
        >
          {btnText}
        </button>
        <button
          type="submit"
          className="cancelButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleReset();
          }}
        >
          Reset
        </button>
        {/* <button
          type="submit"
          className="cancelButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            setShowPirData(false);
          }}
        >
          Back
        </button> */}
      </>
    );
  };

  return (
    <>
      {/* <Typography className="pirdata">PIR Data Purchasing Info Record (PIR) Data’ </Typography> */}
      {/* <Divider /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          // justifyContent: "space-between"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            // justifyContent: "space-between"
          }}
        >
          {/* <div style={inputStyle}>   
            <input
              value={pirDataValue?.vendor_account}
              //placeholder="Vendor Number"
              autoComplete="off"
              type="text" // Change type to text
              pattern="[0-9]*"
              inputmode="numeric"
              name="vendorNumber"
              onChange={handleChange}
              className="partVendorNumberInputField"
            /> 
          </div> */}
          <div style={vendorInputStyle}>
            <Typography style={{ ...headingStyle, margin: "6px 0px" }}>
              SAP Vendor Number{" "}
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "14px" }}
              >
                *
              </span>
            </Typography>
            <Autocomplete
              popupIcon={
                <DropdownIcon
                  style={{
                    width: "20px",
                    position: "relative",
                    left: "0px",
                  }}
                />
              }
              id="combo-box-demo-sap"
              options={vendorNames}
              // disableClearable={true}
              value={pirDataValue?.vendor_account}
              onChange={(e, value) => {
                handleVendorNameChange(value);
              }}
              renderInput={(params) => (
                <TextField
                  className="formControlSelect"
                  placeholder="SAP Vendor Number"
                  {...params}
                  variant="outlined"
                />
              )}
            />
          </div>
          {/* <div style={inputStyle}>
            <Typography style={headingStyle}>Vendor Material Number <span style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}>*</span></Typography>
            <input
              value={pirDataValue?.supplier_part_number}
              //placeholder="Vendort Part Number"
              type="text"
              autoComplete="off"
              name="supplierPartNumber"
              onChange={handleChange}
              className="partInputField"
            />
          </div> */}
        </div>

        {/* <div style={inputStyle}>
          <Typography style={headingStyle}>Lead Time</Typography>
          <input
            value={pirDataValue?.lead_time_from_pir}
            //placeholder="Lead Time"
            type="text"
            name="leadTime"
            onChange={handleChange}
            className="partInputField"
          />
        </div> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            // justifyContent: "space-between"
          }}
        >
          <div style={inputStyle}>
            <Typography style={headingStyle}>
              Vendor Material Number{" "}
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <input
              value={pirDataValue?.supplier_part_number}
              //placeholder="Vendort Part Number"
              type="text"
              autoComplete="off"
              name="supplierPartNumber"
              onChange={handleChange}
              className="partInputField"
            />
          </div>
          <div style={inputStyle}>
            <Typography style={headingStyle}>
              Base UOM{" "}
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <FormControl sx={{ m: 1, width: "100px" }}>
              <Select
                value={pirDataValue?.base_uom}
                name="baseUOM"
                onChange={handleChange}
                IconComponent={(props) => (
                  <DropdownIcon
                    {...props} // Pass down required props for proper functionality
                    style={{
                      width: "20px",
                      height: "10px",
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                )}
                MenuProps={MenuProps}
                sx={{
                  height: "32px",
                  borderRadius: "8px",
                  width: "120px", // Optional: Adjust based on your layout
                }}
              >
                {uomOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={inputStyle}>
            <Typography style={headingStyle}>
              Order UOM{" "}
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <FormControl sx={{ m: 1, width: "100px" }}>
              <Select
                value={pirDataValue?.order_uom}
                name="orderUOM"
                onChange={handleChange}
                IconComponent={(props) => (
                  <DropdownIcon
                    {...props} // Pass down required props for proper functionality
                    style={{
                      width: "30px",
                      height: "10px",
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                )}
                MenuProps={MenuProps}
                sx={{ height: "32px", borderRadius: "8px" }}
              >
                {uomOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {/* {pirDataValue?.base_uom !== pirDataValue?.order_uom &&
            pirDataValue?.base_uom !== "" &&
            pirDataValue?.order_uom !== "" && ( */}
          <div style={inputStyle}>
            <Typography style={headingStyle}>Conversion</Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <input
                value={conversionValue?.base_unit}
                type="text" // Change type to text
                pattern="[0-9]*"
                inputmode="numeric"
                name="conversionBase"
                onChange={handleConversionChange}
                autoComplete="off"
                className="conversionInputField"
              />
              <Typography className="conversionValue">
                {pirDataValue?.base_uom}
              </Typography>
              <Typography className="conversionEqual">==</Typography>
              <input
                value={conversionValue?.order_unit}
                autoComplete="off"
                type="text" // Change type to text
                pattern="[0-9]*"
                inputmode="numeric"
                name="conversionOrder"
                onChange={handleConversionChange}
                className="conversionInputField"
              />
              <Typography className="conversionValue">
                {pirDataValue?.order_uom}
              </Typography>
            </div>
          </div>
          {/* )} */}
        </div>

        {/* <div style={inputStyle}>
          <Typography style={headingStyle}>Predicted Usage</Typography>
          <input
            value={pirDataValue?.predticed_usage}
            //placeholder="Predicted Usage"
            type="text"
            name="predictedUsage"
            onChange={handleChange}
            className="partInputField"
          />
        </div> */}
        <div style={inputStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                style={{
                  fontWeight: "700",
                  position: "relative",
                  left: "12px",
                }}
              >
                Price Unit
                <span
                  style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
                >
                  *
                </span>
              </Typography>
              <input
                value={pirDataValue?.standard_price}
                //placeholder="Net Price($)"
                type="text" // Change type to text
                pattern="[0-9,/.\\-\s]*"
                inputmode="numeric"
                name="netPrice"
                autoComplete="off"
                onChange={handleChange}
                className="partInputField"
                style={{ width: "80px" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <Typography
                style={{
                  fontWeight: "700",
                  position: "relative",
                  left: "12px",
                }}
              >
                Price UOM
                <span
                  style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
                >
                  *
                </span>
              </Typography>
              <FormControl
                sx={{
                  m: 1,
                  width: "70px",
                  position: "relative",
                  left: "-10px",
                }}
              >
                <Select
                  value={currency}
                  onChange={handleSelectChange}
                  IconComponent={(props) => (
                    <DropdownIcon
                      {...props} // Pass down required props for proper functionality
                      style={{
                        width: "30px",
                        height: "10px",
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                    />
                  )}
                  sx={{ height: "32px", borderRadius: "8px", width: "100px" }}
                >
                  {options.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            // justifyContent: "space-between"
          }}
        >
          <div style={inputStyle}>
            <Typography
              style={{ fontWeight: "700", position: "relative", left: "12px" }}
            >
              Annual Predicted Usage
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <input
                value={pirDataValue?.predticed_usage}
                //placeholder="Net Price($)"
                type="text" // Change type to text
                pattern="[0-9]*"
                inputmode="numeric"
                autoComplete="off"
                name="predictedUsage"
                onChange={handleChange}
                className="partInputField"
                style={{ width: "190px" }}
              />
              {/* <FormControl
              sx={{ m: 1, width: "105px", position: "relative", left: "-10px" }}
            >
              <Select
                value={predictedUsage}
                onChange={handlePredicatedValueChange}
                IconComponent={() => (
                  <DropdownIcon
                    style={{
                      width: "40px",
                      position: "relative",
                      left: "-10px",
                    }}
                  />
                )}
                sx={{ height: "32px", borderRadius: "8px" }}
              >
                {leadTimeOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "baseline",
              color: "#212F37",
              margin: "0px 10px",
              width: "170px",
            }}
          >
            <Typography
              style={{ fontWeight: "700", position: "relative", left: "12px" }}
            >
              Lead Time
              <span
                style={{ color: "#C6003D", margin: "4px", fontSize: "20px" }}
              >
                *
              </span>
            </Typography>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <input
                value={pirDataValue?.lead_time_from_pir}
                //placeholder="Net Price($)"
                type="text" // Change type to text
                pattern="[0-9]*"
                inputmode="numeric"
                name="leadTime"
                onChange={handleChange}
                autoComplete="off"
                className="partInputField"
                style={{ width: "80px" }}
              />
              <FormControl
                sx={{
                  m: 1,
                  width: "105px",
                  position: "relative",
                  left: "-10px",
                }}
              >
                <TextField
                  variant="outlined"
                  value={"Days"}
                  // onChange={handleLeadTimeChange}
                  disabled
                  InputProps={{
                    sx: {
                      height: "32px",
                      borderRadius: "8px",
                      backgroundColor: "#f0f0f0", // Set the background color
                      color: "#000", // Set the text color
                      cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                      "&:hover": {
                        backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                      },
                      width: "68px",
                    },
                  }}
                  fullWidth
                />
              </FormControl>
            </div>
          </div>
        </div>

        {/* {pirDataValue?.standard_price <= 15 &&
          pirDataValue?.standard_price !== "" && (
            <div style={inputStyleJustfication}>
              <Typography style={headingStyle}>Enter Justification</Typography>
              <input
                value={pirDataValue?.justification_for_net_price_change}
                //placeholder="Enter Justification"
                type="text"
                autoComplete="off"
                // style={{ background: pirDataValue?.standard_price > 15 ? "#EFEFEF" : "#FFFFFF" }}
                // disabled={pirDataValue?.standard_price > 15}
                name="enterJustification"
                onChange={handleChange}
                className="partInputField"
              />
            </div>
          )} */}

        {/* <button className="buttonCancel">
          Confirm
        </button> */}
      </div>
      <div style={{ margin: "25px" }}>
        <ButtonFamily btnText="Next" />
      </div>
      <JustificationDialog
        open={justificationOpen}
        setJustificationOpen={setJustificationOpen}
        valueData={pirDataValue?.justification_for_net_price_change}
        setPirDataValue={setPirDataValue}
        pirDataValue={pirDataValue}
        setPirValue={setPirValue}
        showButton={true}
        handleContinue={handleContinue}
      />
    </>
  );
};
export default PirData;
